import { Component, ElementRef, ViewChild, Input } from "@angular/core";
import { LinkTarget } from "src/app/types/link";
import { MenuItem } from "src/app/types/menu";

export interface AccordionItem extends MenuItem {
  target?: LinkTarget;
  enabled?: boolean;
  expanded?: boolean;
  content?: string;
  children: AccordionItem[];
}

@Component({
  selector: "app-accordion",
  templateUrl: "./accordion.component.html",
  styleUrls: ["./accordion.component.scss"],
})
export class AccordionComponent {
  @ViewChild("expandWrapper", { read: ElementRef }) expandWrapper: ElementRef;
  @Input("expanded") expanded: boolean = false;

  constructor() {}
}
